/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import {NOTIFICATION_TYPE, Store} from 'react-notifications-component'
import Constants from '../Constants';

const showNotification = (type: NOTIFICATION_TYPE, title: string, message: string | null = null) => {
    Constants.executeWithoutLoader(() => {
        Store.addNotification({
            insert: 'top',
            container: 'top-right',
            animationIn: ['animate__animated', 'animate__fadeIn'],
            animationOut: ['animate__animated', 'animate__fadeOut'],
            dismiss: {
                duration: 3000,
                onScreen: true
            },
            type,
            title,
            message,
        })
    });
}

const Notifications = {
    success: (title: string, message: string | null = null) => showNotification('success', title, message),
    error: (title: string, message: string | null = null) => showNotification('danger', title, message)
}

export default Notifications
